import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 2단계에서 만든 언어 파일들을 가져옵니다.
import ko from '@/locales/ko.json';
import en from '@/locales/en.json';
import vi from '@/locales/vi.json';

Vue.use(VueI18n);

// 브라우저의 기본 언어 설정을 확인합니다.
const userLanguage = navigator.language.split('-')[0];

export const i18n = new VueI18n({
    locale: userLanguage,
    fallbackLocale: 'en',
    messages: {
        ko,
        en,
        vi
    },
    silentTranslationWarn: true, // 번역 키가 없을 때 콘솔에 경고 메시지를 띄우지 않음
});
